import type { AxiosRequestConfig } from "axios"

export interface LegacyRequestHeaderConfig extends AxiosRequestConfig {
  customHeaders?: Record<string, string>
  sensitiveApprovalBusinessName?: string
}

interface LegacyRequestHeaderDeps {
  approvalBusinessNameHeader: string
  zodanceVersion?: string
  token?: string
}

function toHeaderRecord(headers: AxiosRequestConfig["headers"] | undefined): Record<string, any> {
  if (!headers) {
    return {}
  }
  if (typeof (headers as any).toJSON === "function") {
    return (headers as any).toJSON()
  }
  return { ...(headers as Record<string, any>) }
}

function getHeaderValue(headers: Record<string, any>, name: string) {
  return headers[name] ?? headers[name.toLowerCase()]
}

function omitUndefinedHeaders(headers: Record<string, any>) {
  return Object.fromEntries(
    Object.entries(headers).filter(([, value]) => value !== undefined),
  )
}

export function buildLegacyRequestHeaders(
  config: LegacyRequestHeaderConfig,
  deps: LegacyRequestHeaderDeps,
): Record<string, any> {
  const explicitHeaders = toHeaderRecord(config.headers)
  const sensitiveApprovalBusinessName = config.sensitiveApprovalBusinessName?.trim()
  const authorization = deps.token ? `Bearer ${deps.token}` : undefined
  return omitUndefinedHeaders({
    ...config.customHeaders,
    Authorization: authorization,
    "Tenant-Id": "teashop",
    "Content-Type": getHeaderValue(explicitHeaders, "Content-Type") ?? "application/json",
    "ZODANCE-VERSION": deps.zodanceVersion,
    "X-FROM": "teashop_merchant",
    ...(sensitiveApprovalBusinessName
      ? { [deps.approvalBusinessNameHeader]: encodeURIComponent(sensitiveApprovalBusinessName) }
      : {}),
    ...explicitHeaders,
  })
}
